<template>
  <v-badge
    :content="parseInt(unreadCount)"
    color="red"
    v-if="unreadCount > 0"
    overlap
    offset-x="6"
    offset-y="6"
  >
    <v-icon @click="handleClick" class="cursor-pointer">mdi-bell</v-icon>
  </v-badge>
  <v-icon
    v-else
    @click="$emit('toggle')"
    class="cursor-pointer"
  >
    mdi-bell
  </v-icon>
</template>

<script>
export default {
  name: 'NotificationIcon',
  props: {
    unreadCount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    handleClick() {
      console.log('[NotificationIcon] 🔔 Clicked - emitting toggle');
      this.$emit('toggle');
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
